<script>
    import _ from 'lodash'
    import moment from 'moment'
    import OrgService from '@/request/user/org'
    import OperationService from '@/request/aims/operation'
    import AnesthesiaModeService from '@/request/aims/anesthesiaMode'
    import { mapGetters } from 'vuex'
    export default {
        components: {},
        computed: {
            ...mapGetters('operation', {
                storeOptions: 'options'
            })
        },
        data () {
            return {
                pagination: {
                    sort: 'arrangedStartTime',
                    order: 'DESC',
                    current: 1,
                    size: 10,
                    total: 0,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    sizes: [10, 20, 30]
                },
                options: {
                    start: null,
                    end: null,
                    orgs: null,
                    status: '4,5',
                    match: null,
                    incisionType: null
                },
                tableCellStyle: {
                    padding: 0
                },
                hospitals: [],
                chid: null,
                oids: [],
                operationLoading: false,
                operations: [],
                currentOperation: {},
                visibleRecordImage: false,
                dateScope: [],
                defAnesthesiaOperation: null,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick (picker) {
                            const end = moment().endOf('day').valueOf()
                            const start = end - 3600 * 1000 * 24 * 7
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '本月',
                        onClick (picker) {
                            const end = moment().endOf('day').valueOf()
                            const start = moment().startOf('month').valueOf()
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近一个月',
                        onClick (picker) {
                            const end = moment().endOf('day').valueOf()
                            const start = end - 3600 * 1000 * 24 * 30
                            picker.$emit('pick', [start, end])
                        }
                    }]
                }
            }
        },
        created: function () {
            this.chid = this.storeOptions.hid || null
            this.listHospital()
        },
        mounted: function () {},
        beforeDestroy: function () {},
        watch: {
            oids (val) {
                this.$set(this.options, 'orgs', _.isEmpty(val) ? null : _.join(val))
            },
            chid() {
                this.listOids()
                this.loadDefAnesthesiaOperation()
            },
            dateScope () {
                _.assign(this.options, {
                    start: !_.isEmpty(this.dateScope) ? this.dateScope[0] || null : null,
                    end: !_.isEmpty(this.dateScope) ? moment(this.dateScope[1]).endOf('day').valueOf() || null : null
                })
            },
            options: {
                deep: true,
                handler () {
                    this.listOperation()
                }
            }
        },
        methods: {
            listHospital () {
                OrgService.listOrg({
                    parents: 1,
                    typeSns: 'lx0001001'
                }).then(res => {
                    this.hospitals = _.cloneDeep(res.result || [])
                    if (!_.isEmpty(this.hospitals) && !this.chid) {
                        this.chid = this.hospitals[0].id
                    } else if (this.chid) {
                        this.listOids()
                    }
                })
            },
            listOids () {
                let self = this
                if (!self.chid) {
                    self.oids = []
                    return
                }
                OrgService.listOrgId({
                    pids: self.chid,
                    descendant: 1
                }).then(res => {
                    self.oids = res.result || []
                })
            },
            loadDefAnesthesiaOperation() {
                if (!this.chid) {
                    this.defAnesthesiaOperation = null
                    return
                }
                AnesthesiaModeService.listOperation({
                    hid: this.chid
                }).then(res => {
                    if (res && res.result.length) {
                        this.defAnesthesiaOperation = _.find(res.result, o => o.def === 1)
                    } else {
                        this.defAnesthesiaOperation = null
                    }
                })
            },
            handleSizeChange: function (val) {
                this.pagination.size = val
                this.listOperation()
            },
            handleCurrentChange: function (val) {
                this.pagination.current = val
                this.listOperation()
            },
            listOperation () {
                let self = this
                if (_.isEmpty(self.oids)) {
                    self.operations = []
                    return
                }
                self.operationLoading = true
                OperationService.find(this.pagination, this.options).then(res => {
                    let data = res.result
                    self.operations = _.clone(data.content || [])
                    self.pagination.total = data.totalElements || 0
                }).finally(() => {
                    self.operationLoading = false
                })
            },
            tableTimeFormatter (row, column, cellValue) {
                if (!cellValue) {
                    return ''
                }
                return moment(cellValue).format('YYYY-MM-DD HH:mm')
            },
            showRecordImages (operation) {
                if (!operation) {
                    return
                }
                this.currentOperation = _.cloneDeep(operation)
                this.visibleRecordImage = true
            },
            exportExcel () {
                if (_.isEmpty(this.oids)) {
                    this.$message({
                        message: '需要选择医院后导出',
                        type: 'warning'
                    })
                    return
                }
                if (!this.options.start) {
                    this.$message({
                        message: '需要选择时间后导出',
                        type: 'warning'
                    })
                    return
                }
                console.log('下载文件')
                OperationService.export(_.assign({}, this.pagination, {order: 'ASC'}), this.options)
            }
        },
        filters: {}
    }
</script>

<template>
    <el-container>
        <el-header height="45px">
            <el-form :inline="true" class="demo-form-inline" size="small">
                <el-form-item>
                    <el-button @click="$router.go(-1)">返 回</el-button>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="chid" placeholder="请选择医院" :disabled="hospitals.length <= 1">
                        <el-option
                                v-for="item in hospitals"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="dateScope"
                            type="daterange"
                            format="yyyy年MM月dd日"
                            value-format="timestamp"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            range-separator="至"
                            :picker-options="pickerOptions"
                            clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="options.incisionType" placeholder="请选择切口类型" clearable>
                        <el-option label="〇" value="〇"></el-option>
                        <el-option label="Ⅰ" value="Ⅰ"></el-option>
                        <el-option label="Ⅱ" value="Ⅱ"></el-option>
                        <el-option label="Ⅲ" value="Ⅲ"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="options.match" placeholder="请输入查找" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportExcel" :disabled="!options.start">导出excel</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                <el-table
                        v-loading="operationLoading"
                        :data="operations"
                        border
                        stripe
                        size="mini"
                        highlight-current-row
                        :cell-style="tableCellStyle"
                        :header-cell-style="tableCellStyle"
                        empty-text="暂时没有您参与的手术"
                        style="width: 100%">
                    <el-table-column prop="arrangedStartTime" label="时间" width="120" :formatter="tableTimeFormatter"></el-table-column>
                    <el-table-column prop="orgName" label="科室"></el-table-column>
                    <el-table-column prop="historySn" label="病历号" width="70"></el-table-column>
                    <el-table-column prop="patName" label="姓名" width="60"></el-table-column>
                    <el-table-column prop="sex" label="性别" width="40">
                        <template slot-scope="scope">
                            {{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" width="40"></el-table-column>
                    <el-table-column prop="diagnoseNames" label="诊断+术式">
                        <template slot-scope="scope">
                            <span>{{scope.row.diagnoseNames}};{{scope.row.operatingNames}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incisionType" label="切口类型" width="80"></el-table-column>
                    <el-table-column prop="device" label="设备准备" width="120"></el-table-column>
                    <el-table-column prop="specialPrepare" label="器械准备"></el-table-column>
                    <el-table-column prop="operatorName" label="主刀" width="60"></el-table-column>
                    <el-table-column prop="assistantFirstName" label="一助" width="60"></el-table-column>
                    <el-table-column prop="assistantSecondName" label="二助" width="60"></el-table-column>
                    <el-table-column prop="washNurseName" label="洗手" width="60"></el-table-column>
                    <el-table-column prop="tourNurseName" label="巡回" width="60"></el-table-column>
                    <el-table-column prop="anesthesiaDocName" label="麻醉师" width="60"></el-table-column>
                    <el-table-column prop="anesthesiaType" label="麻醉方式" width="80"></el-table-column>
                    <el-table-column prop="anesthesiaAdditional" label="操作类型" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.anesthesiaAdditional ? scope.row.anesthesiaAdditional : (defAnesthesiaOperation ? defAnesthesiaOperation.operation : '')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="small" type="text" @click="showRecordImages(scope.row)">查看图片</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
        </el-main>
        <el-footer height="35px">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.current" :page-sizes="pagination.sizes" :page-size="pagination.size" :layout="pagination.layout" :total="pagination.total"></el-pagination>
        </el-footer>
        <!-- 查看图片 -->
        <el-dialog title="图片" top="30px" :visible.sync="visibleRecordImage">
            <record-record-image-list v-if="currentOperation.drid" :record="currentOperation" :enableAdd="false"></record-record-image-list>
            <div v-else>没有关联病历</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visibleRecordImage = false">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
